import React, { useEffect } from "react"
import { Redirect, Route } from "react-router-dom"
// eslint-disable-next-line no-restricted-imports -- FIXME: Usages of styled-components should be replaced with components from @carrotfertility/carotene-core or @carrotfertility/carotene-core-x. Please do not import styled-components after eslint rule added on 3/21/2025.
import { ThemeProvider } from "styled-components"
import { fleFormTheme } from "#/utils/formThemes"
import RoutingFlow from "."
import { CarrotPlansPaths, Paths } from "../../utils/Paths"
import { Switch } from "#/services/routing/Switch"
import { useMemberBenefitStarted } from "#/services/user/derived-selectors/member-info"
import useCarrotPlan from "./hooks/useCarrotPlan"
import {
  CarrotPlanRequestType,
  useGetInProgressCarrotPlanRequestType
} from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"
import useCarrotPlanEmployeeSettings from "#/components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"
import { useStartRouting } from "#/components/carrot-plans/shared/useQueryStartRouting"
import { RoutingFlowType } from "#/components/carrot-plans/types/routingFlowType"
interface ProtectFlowProps {
  children: React.ReactElement
}

function ProtectFlow({ children }: ProtectFlowProps): JSX.Element {
  const benefitStarted = useMemberBenefitStarted()
  const carrotPlanQuery = useCarrotPlan()
  const carrotPlanEmployeeSettings = useCarrotPlanEmployeeSettings()
  const { startRouting } = useStartRouting(RoutingFlowType.CASE_RATE_RENEWAL)

  useEffect(() => {
    if (carrotPlanEmployeeSettings.isDoneForNow) {
      startRouting()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carrotPlanEmployeeSettings.isDoneForNow])

  if (benefitStarted.isLoading || carrotPlanEmployeeSettings.isLoading) {
    return null
  }

  if (!benefitStarted.data || (carrotPlanQuery?.hasCarrotPlan && !carrotPlanEmployeeSettings?.isDoneForNow)) {
    return <Redirect to={Paths.HOME} />
  }

  return children
}

function RedirectToCarrotPlansNextStep(): JSX.Element {
  const inProgressCarrotPlanRequestType = useGetInProgressCarrotPlanRequestType()

  switch (inProgressCarrotPlanRequestType.data) {
    case CarrotPlanRequestType.INITIAL_INTAKE:
      return <Redirect to={CarrotPlansPaths.ENROLLMENT} />
    case CarrotPlanRequestType.RENEWAL_INTAKE:
      return <Redirect to={CarrotPlansPaths.CASE_RATE_RENEWAL} />
    case CarrotPlanRequestType.JOURNEY_CHANGE_INTAKE:
      return <Redirect to={CarrotPlansPaths.JOURNEY_CHANGE} />
    case CarrotPlanRequestType.CHECK_IN_INTAKE:
      return <Redirect to={CarrotPlansPaths.CHECK_IN_EXPERIENCE} />
    default:
      return <Redirect to={CarrotPlansPaths.ENROLLMENT} />
  }
}

export function CarrotPlansRouter(): JSX.Element {
  return (
    <ThemeProvider theme={fleFormTheme}>
      <Switch>
        <Route exact path={CarrotPlansPaths.ENROLLMENT}>
          <ProtectFlow>
            <RoutingFlow />
          </ProtectFlow>
        </Route>
        <Route path={CarrotPlansPaths.REDIRECT}>
          <RedirectToCarrotPlansNextStep />
        </Route>
      </Switch>
    </ThemeProvider>
  )
}
